import { render } from "./trash.vue?vue&type=template&id=27c4a91a"
const script = {}
script.render = render

export default script